import { useContext, useEffect, useState } from 'react'
import ContentPage, {
	BottomPage,
	HeaderPage,
} from '../../../../components/Tabs/ContentPage'

import {
	formatCustomWeek,
	getFirstDayOfWeek,
	getCurrentWeekYear,
} from '../../../../helper/ValidateFormat'
import { useSearchParams } from 'react-router-dom'

import WeekTable from './Table'
// import CustomInput from '../../../../components/Datepicker/CustomInput'

import Header from './Header'
import { PageContext } from '../context'
import { useReplaceSearchParams } from '../../../../helper/UrlParams'
import LegendTemperature from '../LegendTemperature'
import TemperatureExport from '../TemperatureExport'
import { startOfWeek } from 'date-fns'

const TemperatureWeek = () => {
	const [searchParams] = useSearchParams()
	const [currentWeek, setCurrentWeek] = useState(null)
	const [deviceid, setDeviceid] = useState(null)
	const [showGraph, setShowGraph] = useState(false)
	const { allDevices } = useContext(PageContext)

	const replaceSearchParams = useReplaceSearchParams()

	useEffect(() => {
		// TODO: Implement a logic to check, if deviceid is in allDevices and currentWeek is possible (helpers should be already there)
		const thisWeek = searchParams.get('week')
		const thisDeviceid = searchParams.get('deviceid')
		const getThisWeek = formatCustomWeek(getFirstDayOfWeek(getCurrentWeekYear()))
		const resolvedWeek = thisWeek || getThisWeek

		setCurrentWeek(getFirstDayOfWeek(resolvedWeek))

		if (allDevices === null) return

		const firstDeviceId = allDevices.find(device => !device.isIoModule)?.id
		const hasSelectedDevice = allDevices.some(
			device => device.id === thisDeviceid
		)
		const needsDeviceId =
			!thisDeviceid || thisDeviceid === 'null' || !hasSelectedDevice

		let newParams = {}
		if (!thisWeek && needsDeviceId && firstDeviceId) {
			newParams = {
				deviceid: firstDeviceId,
				week: getThisWeek,
			}
			replaceSearchParams(newParams)
		} else if (thisWeek && needsDeviceId && firstDeviceId) {
			newParams = { deviceid: firstDeviceId }
			replaceSearchParams(newParams)
		} else if (!thisWeek && thisDeviceid) {
			newParams = { week: getThisWeek }
			replaceSearchParams(newParams)
		} else if (!thisWeek && needsDeviceId) {
			setDeviceid(null)
		} else {
			setDeviceid(thisDeviceid)
		}
	}, [searchParams, allDevices])

	const changeDateHandler = date => {
		setCurrentWeek(startOfWeek(date, { weekStartsOn: 1 }))
		const newParams = { week: formatCustomWeek(date) }
		if (deviceid) newParams.deviceid = deviceid
		replaceSearchParams(newParams)
	}

	const toggleChart = () => setShowGraph(!showGraph)
	const selectedDevice = (allDevices || []).find(
		device => device.id === deviceid
	)
	const canShowGraph = !selectedDevice?.isIoModule

	// TODO: Find a better solution for that
	if (!currentWeek) {
		return <></>
	}

	return (
		<>
			<HeaderPage Export={<TemperatureExport currentWeek={currentWeek} />}>
				<Header
					toggleChart={toggleChart}
					changeDateHandler={changeDateHandler}
					currentDate={currentWeek}
					deviceid={deviceid}
				/>
			</HeaderPage>
			<ContentPage>
				<WeekTable
					currentWeek={currentWeek}
					deviceid={deviceid}
					showGraph={showGraph && canShowGraph}
				/>
			</ContentPage>
			<BottomPage>
				<LegendTemperature />
			</BottomPage>
		</>
	)
}

export default TemperatureWeek
